export const translations = {
  pl: {
    hero: {
      subtitle1: "Better Pictures",
      subtitle2: "Operator kamery i drona · Fotograf · Produkcja wideo dla marek",
    },
    about: {
      label: "O mnie",
      heading: "TWORZĘ WIDEO, KTÓRE WYGLĄDA FILMOWO\nI PRACUJE NA WYNIK\n",
      paragraph1:
        "Operator kamery i drona, fotograf oraz producent wykonawczy z ponad 10-letnim doświadczeniem w produkcji wideo, reklamie i contencie dla marek.\nPracuję z domami produkcyjnymi, agencjami kreatywnymi i klientami korporacyjnymi — realizowałem projekty dla kina, streamingu (Netflix, HBO), telewizji (TVN, Polsat) i marek: Red Bull, Polskie Porty Lotnicze, NEXTBIKE, Toyota, Volvo, Range Rover, Polpharma, Popkiller, BNP, PGE i wielu innych.\nOgarniam zdjęcia, drona, światło, ekipę, produkcję i postprodukcję — z własnym zapleczem sprzętowym.\n",
      paragraph2:
        "KAMERA | DRON | FOTOGRAF | PRODUCENT FILMOWY | 10+ LAT W BRANŻY",
    },
    services: {
      label: "Usługi",
      heading: "Co robię",
      photography: {
        title: "Foto",
        description:
          "Fotografia reklamowa, portretowa i eventowa dla firm, twórców i marek. Kadry, które dobrze wyglądają w kampanii, na stronie, w socialach i materiałach PR.",
      },
      videography: {
        title: "Wideo",
        description:
          "Filmowa produkcja wideo dla marek, kampanii i social media. Od koncepcji i zdjęć po montaż, kolor i gotowe formaty na www, YouTube, Instagram i paid ads.",
      },
      branding: {
        title: "Kierownictwo Kreatywne",
        description:
          "Kreatywne prowadzenie produkcji: od pomysłu, scenariusza i moodboardu po plan zdjęciowy, dobór ekipy, formaty pod social media i finalny materiał.",
      },
      creativeDirection: {
        title: "Zdjęcia Lotnicze",
        description:
          "Zdjęcia i ujęcia dronowe do filmów, reklam, eventów, nieruchomości i dokumentacji. Loty realizuję z wymaganymi uprawnieniami (A1/A2 i NSTS), procedurami i ubezpieczeniem OC.",
      },
    },
    video: {
      label: "Wideo",
      heading: "Produkcje Wideo",
    },
    photo: {
      label: "Fotografia",
      heading: "Wybrane Zdjęcia",
    },
    contact: {
      label: "Kontakt",
      heading: "Pracujmy Razem!",
      namePlaceholder: "Twoje imię",
      emailPlaceholder: "Twój email",
      messagePlaceholder: "Twoja wiadomość",
      sendButton: "Wyślij wiadomość",
      sending: "Wysyłanie...",
      getInTouch: "Skontaktuj się",
      getInTouchText:
        "Masz projekt wideo, kampanię, event albo potrzebujesz mocnych kadrów z ziemi i powietrza? Napisz — zróbmy obraz, który wygląda dobrze i działa w praktyce.",
      toastTitle: "Wiadomość wysłana!",
      toastDescription: "Dziękuję za kontakt. Odezwę się wkrótce.",
      footer: "better pictures",
      copyright: "Michał Wencek. Wszelkie prawa zastrzeżone.",
    },
  },
  en: {
    hero: {
      subtitle1: "Better Pictures",
      subtitle2: "Camera & Drone Operator · Photographer · Video Production for Brands",
    },
    about: {
      label: "About",
      heading: "I create video that looks good and works well",
      paragraph1:
        "Camera and drone operator, executive producer with over 10 years of experience working with production houses, agencies and corporate clients. Projects for Cinema, Streaming (Netflix, HBO), TV (TVN, Polsat) and brands such as RedBull, Polskie Porty Lotnicze, NEXTBIKE, Toyota, Volvo, Range Rover, Polpharma, Popkiller BNP, PGE and many others. Full-service production – from pre-production to post-production, with complete equipment support.",
      paragraph2:
        "CAMERA | DRONE | PHOTOGRAPHER | FILM PRODUCER | 10+ YEARS IN THE INDUSTRY",
    },
    services: {
      label: "Services",
      heading: "What I Do",
      photography: {
        title: "Photo",
        description:
          "Professional photography for brands, portraits, and events. Creating images that tell your story.",
      },
      videography: {
        title: "Video",
        description:
          "Cinematic video production from concept to final edit. Bringing your vision, emotions and story to life in motion.",
      },
      branding: {
        title: "Creative Direction",
        description:
          "Strategic creative guidance for campaigns and projects. Turning ideas and your emotions into tailored visuals and stories.",
      },
      creativeDirection: {
        title: "Aerial Photography",
        description:
          "Drone shots that show the world from a new perspective. Spectacular intentional views, with full safety (A1/A2/A2 and NSTS licenses, liability insurance).",
      },
    },
    video: {
      label: "Video",
      heading: "Video Productions",
    },
    photo: {
      label: "Photography",
      heading: "Selected Photos",
    },
    contact: {
      label: "Contact",
      heading: "Let's Work Together",
      namePlaceholder: "Your Name",
      emailPlaceholder: "Your Email",
      messagePlaceholder: "Your Message",
      sendButton: "Send Message",
      sending: "Sending...",
      getInTouch: "Get in Touch",
      getInTouchText:
        "Have a project in mind or just want to say hello? I'd love to hear from you. Let's create something amazing together.",
      toastTitle: "Message sent!",
      toastDescription: "Thank you for reaching out. I'll get back to you soon.",
      footer: "better pictures",
      copyright: "Michał Wencek. All rights reserved.",
    },
  },
} as const;

export type Language = keyof typeof translations;

// Use a structural type instead of literal types from one language
type DeepStringify<T> = {
  [K in keyof T]: T[K] extends string ? string : DeepStringify<T[K]>;
};

export type Translations = DeepStringify<typeof translations.pl>;
